export const useEventNameConstructor = ({ screenId = '' }) => {
  const keys = {
    load: '__screen__load',
    click: '__click',
  }

  return (eventKey: 'load' | 'click') => `${screenId}${keys[eventKey]}`
}
